import { render, staticRenderFns } from "./ScheckboxPreview.vue?vue&type=template&id=345333a6&"
import script from "./ScheckboxPreview.vue?vue&type=script&lang=js&"
export * from "./ScheckboxPreview.vue?vue&type=script&lang=js&"
import style0 from "./ScheckboxPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports